import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const ActionStatus = () => {
  const [stage, setStage] = useState(0);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const action = searchParams.get('action') || 'accept';
  const isAccept = action === 'accept';

  useEffect(() => {
    const timers = [
      setTimeout(() => setStage(1), 200),
      setTimeout(() => setStage(2), 500),
      setTimeout(() => setStage(3), 800),
    ];

    return () => timers.forEach(clearTimeout);
  }, []);

  const handleButtonClick = () => {
    navigate('/');
  };

  return (
    <div className={`min-h-screen bg-gradient-to-br ${isAccept ? 'from-green-500 via-emerald-600 to-teal-700' : 'from-red-500 via-red-600 to-red-800'} flex items-center justify-center p-4 relative overflow-hidden`}>

      {/* Background glow */}
      <div className="absolute w-[500px] h-[500px] bg-purple-400/30 blur-3xl rounded-full top-[-100px] right-[-100px]" />
      <div className="absolute w-[400px] h-[400px] bg-blue-400/20 blur-3xl rounded-full bottom-[-100px] left-[-100px]" />

      {/* Card */}
      <div className={`backdrop-blur-xl bg-white/10 border border-white/20 rounded-2xl p-10 w-full max-w-md text-center shadow-2xl transition-all duration-700 ${stage >= 1 ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
        }`}>

        {/* Icon Container */}
        <div className="relative flex justify-center mb-6">
          <div className={`w-24 h-24 rounded-full ${isAccept ? 'bg-green-500' : 'bg-red-500'} flex items-center justify-center shadow-lg transition-all duration-500 ${stage >= 2 ? 'scale-100 opacity-100' : 'scale-50 opacity-0'
            }`}>
            <svg className="w-12 h-12 text-white" viewBox="0 0 52 52">
              {isAccept ? (
                <path
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeDasharray="48"
                  strokeDashoffset={stage >= 2 ? 0 : 48}
                  className="transition-all duration-700 ease-out"
                  d="M14 27l7 7 16-16"
                />
              ) : (
                <path
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeDasharray="48"
                  strokeDashoffset={stage >= 2 ? 0 : 48}
                  className="transition-all duration-700 ease-out"
                  d="M34 14 L14 34 M14 34 L34 14"
                />
              )}
            </svg>
          </div>

          {/* Pulse ring */}
          {stage >= 2 && (
            <div className={`absolute w-24 h-24 rounded-full border-4 ${isAccept ? 'border-green-300' : 'border-red-300'} animate-ping opacity-30`} />
          )}
        </div>

        {/* Title */}
        <h1 className={`text-3xl md:text-4xl font-bold text-black mb-3 transition-all duration-700 ${stage >= 2 ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
          }`}>
          {isAccept ? 'Accepted' : 'Rejected'}
        </h1>

        {/* Message */}
        <p className={`text-black/80 text-lg transition-all duration-700 delay-100 ${stage >= 3 ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
          }`}>
          {isAccept
            ? 'The request has been accepted successfully!'
            : 'The request has been rejected.'}
        </p>

        {/* Divider */}
        <div className={`mt-6 h-px bg-white/20 transition-all duration-700 ${stage >= 3 ? 'opacity-100 scale-x-100' : 'opacity-0 scale-x-0'
          }`} />

        {/* Button */}
        <button
          className={`mt-6 px-6 py-3 rounded-lg font-semibold transition-all duration-300 shadow-md ${isAccept ? 'bg-white text-green-700 hover:bg-white/90' : 'bg-white text-red-700 hover:bg-white/90'} ${stage >= 3 ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
            }`}
          onClick={handleButtonClick}
        >
          Go to Dashboard
        </button>
      </div>
    </div>
  );
};

export default ActionStatus;